import React, { useState, useEffect, useRef } from 'react';
import DownArrowIconLight from '/src/assets/down-arrow-icon-light.svg';
import DownArrowIconDark from '/src/assets/down-arrow-icon-dark.svg';
import UpArrowIconLight from '/src/assets/up-arrow-icon-light.svg';
import './style.css';

const PropertyNavigationMobile = ({
    tabs,
    activeTab,
    setActiveTab
}) => {
    const [expandedTab, setExpandedTab] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const handleTabClick = (tabId) => {
        setExpandedTab(expandedTab === tabId ? null : tabId);
    };

    return (
        <div 
            ref={containerRef}
            className={`mobile-navigation-container ${menuOpen ? 'open' : ''}`}
        >
            <button
                className={`navigation-toggle-button  ${menuOpen ? '' : 'box-shadow-standard'}`}
                onClick={toggleMenu}
            >
                Analysis Sections
                <img
                    src={menuOpen ? UpArrowIconLight : DownArrowIconLight}
                    alt="Toggle Navigation"
                    className="navigation-arrow-icon"
                />
            </button>

            {menuOpen && (
                <div className="tabs-container">
                    {tabs.map(tab => (
                        <div key={tab.id} className="tab-group">
                            <button
                                className={`tab box-shadow-standard ${
                                    activeTab === tab.id ||
                                    tab.children?.some(child => child.id === activeTab) ? 'active' : ''
                                }`}
                                onClick={() => handleTabClick(tab.id)}
                            >
                                <img
                                    src={
                                        activeTab === tab.id ||
                                        tab.children?.some(child => child.id === activeTab) ?
                                        tab.icon_light :
                                        tab.icon_dark
                                    }
                                    alt=""
                                    className="tab-icon"
                                />
                                <span className="tab-name">{tab.name}</span>
                                <img
                                    src={
                                        expandedTab === tab.id ? UpArrowIconLight :
                                            (activeTab === tab.id || tab.children?.some(child => child.id === activeTab)) ?
                                                DownArrowIconLight :
                                                DownArrowIconDark
                                    }
                                    alt=""
                                    className="tab-arrow-icon"
                                />
                            </button>
                            {expandedTab === tab.id && tab.children && (
                                <div className="dropdown-items">
                                    {tab.children.map(child => (
                                        <button
                                            key={child.id}
                                            className={`dropdown-item box-shadow-standard ${activeTab === child.id ? 'active' : 'inactive'}`}
                                            onClick={() => {
                                                setActiveTab(child.id);
                                                setExpandedTab(null); // Close dropdown after selection
                                                setMenuOpen(false); // Close menu after selection
                                            }}
                                        >
                                            <img
                                                src={
                                                    activeTab === child.id ?
                                                    child.icon_light :
                                                    child.icon_dark
                                                }
                                                alt=""
                                                className="dropdown-item-icon"
                                            />
                                            <span className="dropdown-item-name text-align-center">{child.name}</span>
                                            {/* <p className="dropdown-item-headline">{child.headline}</p> */}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default PropertyNavigationMobile;
